import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=573f7b1d"
import script from "./index.js?vue&type=script&lang=js&external"
export * from "./index.js?vue&type=script&lang=js&external"
import style0 from "./index.scss?vue&type=style&index=0&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/jenkins/jenkins_workspace/workspace/vuejs-tb-train-ontraining-web-sim/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('573f7b1d')) {
      api.createRecord('573f7b1d', component.options)
    } else {
      api.reload('573f7b1d', component.options)
    }
    module.hot.accept("./Index.vue?vue&type=template&id=573f7b1d", function () {
      api.rerender('573f7b1d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/sign-in/components/update-classroom-address-dialog/Index.vue"
export default component.exports